import { action, observable } from "mobx";
import {post} from "../../services/ajax-calls.service";
class MedicalPhysiciansStore {
    @observable physicians = []
    @observable physician_details = {}
    @observable physician_claims = []
    @observable url =  "/api/v1/medicalActions/physicians";

    

    @action getPhysicians = async (data) => {
        this.physicians = [];
        try {
            let response = await post(
                `${this.url}/getPhysicians`,
                data
            );
            this.physicians = response.data;
        } catch (err) {
            console.log(err);
        }
    }

    @action getPhysicianClaims = async (data) => {
        this.physician_claims = [];
        try {
            let response = await post(
                `${this.url}/getPhysicianClaims`,
                data
            );
            this.physician_claims = response.data;
        } catch (err) {
            console.log(err);
        }
    }

    @action getPhysicianDetails = async (data) => {
        this.physician_details = {};
        try {
            let response = await post(
                `${this.url}/getPhysicianDetails`,
                data
            );
            this.physician_details = response.data[0];
        } catch (err) {
            console.log(err);
        }
    }
}

export default MedicalPhysiciansStore; 